export const HIGH_SCORE_HEADER =
  "Wow! Your score is top tier, you’re ready to send!";
export const MIDDLE_SCORE_HEADER =
  "Almost ready to send! Let’s make some improvements.";
export const LOW_SCORE_HEADER =
  "Not the best, but let’s work to improve your score!";
